import { StubCostItem } from './cost-item';
import { CostAccordionCategory, DisplayItem } from '../models/production-cost';

export const StubDisplayItem: DisplayItem = {
  ...StubCostItem,
  estimatedTotal: 0,
  isExpanded: false,
};

export const StubCostAccordionCategory: CostAccordionCategory = {
  _id: '',
  project: '',
  department: '',
  name: '',
  items: [],
  estimate: 0,
  actual: 0,
  comments: [],
  hasComment: false,
  open: false,
  disabled: false,
};
